import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Component } from 'react';
var fadeOutStyles = function fadeOutStyles(maxHeight, top, backgroundColor) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  overflow-y: hidden;\n  max-height: ", "px;\n  &::after {\n    content: '';\n    position: absolute;\n    top: ", "px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-image: linear-gradient(\n      ", ",\n      ", "\n    );\n  }\n"])), maxHeight, top, "var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))", backgroundColor);
};
var FadeOut = function FadeOut(props) {
  var children = props.children,
    backgroundColor = props.backgroundColor,
    fadeHeight = props.fadeHeight,
    height = props.height;
  var top = height - fadeHeight;
  var styles = fadeOutStyles(height, top, backgroundColor);
  return jsx("div", {
    css: styles
  }, children);
};
export var TruncatedWrapper = /*#__PURE__*/function (_Component) {
  _inherits(TruncatedWrapper, _Component);
  var _super = _createSuper(TruncatedWrapper);
  function TruncatedWrapper(props) {
    _classCallCheck(this, TruncatedWrapper);
    return _super.call(this, props);
  }

  // TODO: Quality ticket as elevation.surface will be issue when sits top of modal. https://product-fabric.atlassian.net/browse/DSP-4123
  _createClass(TruncatedWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$height = _this$props.height,
        height = _this$props$height === void 0 ? 95 : _this$props$height,
        _this$props$fadeHeigh = _this$props.fadeHeight,
        fadeHeight = _this$props$fadeHeigh === void 0 ? 24 : _this$props$fadeHeigh,
        _this$props$backgroun = _this$props.backgroundColor,
        backgroundColor = _this$props$backgroun === void 0 ? "var(--ds-surface, white)" : _this$props$backgroun,
        children = _this$props.children;
      return jsx(FadeOut, {
        height: height,
        fadeHeight: fadeHeight,
        backgroundColor: backgroundColor
      }, children);
    }
  }]);
  return TruncatedWrapper;
}(Component);